export default __webpack_public_path__ + "static/media/arrow__to-map.e4b2f314.svg";